<template>
  <div class="setting__user">
    <div class="api_body">
      <h2 class="api_header">Manage API Keys</h2>

      <div v-show="pageLoading">
        <div>
          <PageLoader />
        </div>
      </div>

      <div v-show="!pageLoading" class="api_card">
        <table>
          <tr>
            <th>LIVE KEY</th>
            <td>
              <p>{{ apiKeys.live_key }}</p>
            </td>
          </tr>
          <tr>
            <th>TEST KEY</th>
            <td>
              <p>{{ apiKeys.staging_key }}</p>
            </td>
          </tr>
        </table>
        <!-- <div>
          <p>LIVE KEY: {{ apiKeys.live_key }}</p>
        </div>
        <div>
          <p>TEST KEY: {{ apiKeys.staging_key }}</p>
        </div> -->

        <button class="api_btn" @click.prevent="rotateKey">
          <span v-if="loading"><InputLoader /></span>
          <span v-else>Rotate Keys</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import PageLoader from "../../partials/page-loader";
// import InputLoader from "../../partials/input-loader";
import InputLoader from "../../partials/white-loader.vue";

export default {
  name: "ApiKeys",
  components: {
    PageLoader,
    InputLoader,
  },
  data() {
    return {
      apiKeys: {},
      pageLoading: true,
      loading: false,
    };
  },
  methods: {
    rotateKey() {
      this.loading = true;
      this.$http
        .post(types.API_KEYS_ROTATE, {})
        .then((resp) => {
          this.apiKeys = resp.data.data;
          this.pageLoading = false;
          this.loading = false;
        })
        .catch();
    },
  },
  created() {
    this.pageLoading = true;
    this.$http
      .get(types.API_KEYS)
      .then((resp) => {
        this.apiKeys = resp.data.data;
        this.pageLoading = false;
      })
      .catch();
  },
};
</script>

<style lang="scss" scoped>
.api_body {
  text-align: center;

  .api_header {
    font-size: 1.2rem;
    font-weight: 600;
    margin-top: 1rem;
    padding: 1rem;
  }

  .api_card {
    background: #ffffff;
    padding: 2rem;
    border-radius: 4px;
    margin: 0 auto;
    max-width: 40rem;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

    p {
      word-wrap: break-word;
      font-weight: 700;
      margin: 0;
    }
   
    table {
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;
           border-top: 5px solid #5099de;


      th,
      td {
        padding: 1.2rem;
        border: 1px solid #ddd;
        text-align: left;
      }

      th {
        width: 20%;
        background-color: #f2f2f2;
        font-weight: 400;
        font-size: 0.8rem;
      }

      td {
        width: 80%;
      }
    }
  }

  .api_btn {
    background: #5099de;
    color: #ffffff;
    border: none;
    padding: 1rem;
    border-radius: 4px;
    width: 70%;
    margin: 1rem;
    height: 4rem;
  }
  .api_btn:hover {
    background: #274980;
    border: none;
  }
}

.setting__user--permission {
  width: 47.865vw;

  @media (max-width: 768px) {
    width: 23rem;
  }

  > h4 {
    margin-bottom: 30px;
    font-size: 1rem;

    color: #000000;
  }

  > .setting__user--permission-header {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    align-content: center;
    padding-bottom: 20px;

    > .setting__user--permission-name {
      width: 50%;
      padding-left: 10px;
      font-size: 1.042rem;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
    }

    > .setting__user--permission-permission {
      width: 25%;
      padding-left: 10px;
      font-size: 1.042rem;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
    }

    > .setting__user--permission-edit {
      width: 25%;
      padding-left: 10px;
      font-size: 1.042rem;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
    }
  }

  > .setting__user--permission-body {
    border-top: 5px solid #5099de;

    > div {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;
      border-radius: 2px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      height: 50px;
      margin-bottom: 20px;

      .setting__user--permission-name {
        width: 50%;
        padding-left: 10px;

        > span {
          font-size: 0.938rem;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.22;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
          text-decoration: underline;
        }

        > p {
          font-size: 0.938rem;
          font-weight: 300;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.33;
          letter-spacing: normal;
          text-align: left;
          color: #707070;
          margin-top: 15px;
        }
      }

      .setting__user--permission-permission {
        width: 25%;
        padding-left: 10px;
        font-size: 0.938rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.22;
        letter-spacing: normal;
        text-align: left;
        color: #000000;

        > span {
          color: #5099de;
        }
      }

      .setting__user--permission-edit {
        width: 25%;
        padding-left: 10px;
        font-size: 0.833rem;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: 2.5;
        letter-spacing: normal;
        text-align: left;

        > a {
          text-decoration: none;
          color: #f17d6b;
        }
      }
    }
  }
}

.setting__user--add {
  font-size: 1rem;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.22;
  letter-spacing: normal;
  text-align: left;
  margin-top: 36px;
  margin-bottom: 100px;

  > a {
    color: #5099de;
    text-decoration: none;
  }
}
</style>
